module.exports = __webpack_public_path__ + "img/Logo_KreditPro_White.0476516f.png";